import React from 'react';
import * as Styled from './Download.styled';
import CrossPlatformDownloadButton from '@Utils/shared/components/DownloadButtonAndStore/DownloadButtonAndStoreSimple';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';

const Download: React.FC = () => {
  const { strings, links } = useWidget(WidgetId.LogoMakerThankYouRaidIdV3);

  return (
    <Styled.Wrapper>
      <CrossPlatformDownloadButton
        appStoreUrl={links.appleStoreUrl}
        googlePlayUrl={links.googlePlayUrl}
        downloadLink={links.freeDownloadLink}
        downloadText={strings.freeDownload}
      />
    </Styled.Wrapper>
  );
};

export default Download;
